module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-2-2c2ced3aa5849a360f7f88fcba7e67e9.png";